<template>
    <checkout-step>
        <template slot="title">
            {{ __('Bejelentkezés') }}
        </template>

        <div>
            <portal-target
                v-if="portalAvailable"
                name="checkout-authentication-before"
            />

            <div class="form-group row">
                <label
                    for="email"
                    class="col-md-4 col-form-label text-md-right"
                >{{ __('E-Mail Address') }}</label>

                <div class="col-md-6">
                    <input
                        id="email"
                        v-model="email"
                        type="email"
                        class="form-control"
                        :class="{ 'is-invalid': errors.email }"
                        required
                        autocomplete="email"
                    >

                    <span
                        v-if="errors.email"
                        class="invalid-feedback"
                        role="alert"
                    >
                        <strong v-for="message in errors.email">{{ message }}</strong>
                    </span>
                </div>
            </div>

            <div class="form-group row">
                <label
                    for="password"
                    class="col-md-4 col-form-label text-md-right"
                >{{ __('Password') }}</label>

                <div class="col-md-6">
                    <input
                        id="password"
                        v-model="password"
                        type="password"
                        class="form-control"
                        :class="{ 'is-invalid': errors.password }"
                        required
                        autocomplete="current-password"
                    >

                    <span
                        v-if="errors.password"
                        class="invalid-feedback"
                        role="alert"
                    >
                        <strong v-for="message in errors.password">{{ message }}</strong>
                    </span>
                </div>
            </div>

            <div class="form-group row mb-0">
                <div class="col-md-8 offset-md-4">
                    <button
                        class="btn btn-primary"
                        @click="login"
                    >
                        {{ __('Login') }}
                    </button>
                    <a
                        v-if="route().check('password.request')"
                        class="btn btn-link"
                        :href="route('password.request')"
                    >
                        {{ __('Forgot Your Password?') }}
                    </a>
                </div>
            </div>
        </div>

        <portal-target
            v-if="portalAvailable"
            name="checkout-customer-data-after"
        />

        <template
            slot="navigation"
            slot-scope="{ prev, next }"
        >
            <button
                v-if="currentStep !== 1"
                type="button"
                class="btn btn-danger btn-back"
                @click="prev()"
            >
                {{ __('Back') }}
            </button>
            <button
                class="btn btn-secondary float-right"
                @click="$bus.$emit('checkout-step-next')"
            >
                {{ __('Folytatás bejelentkezés nélkül') }}
            </button>
        </template>
    </checkout-step>
</template>

<script>
import authenticationBase from '../../../mixins/checkout/authenticationBase'

export default {
    name: 'Authentication',
    mixins: [authenticationBase],
}
</script>

